import React from 'react';
import { About, Menu, Top } from '../../components';

const Home = () => {
    return (
        <>
            <Top />
            <Menu />
            <About />
        </>
    );
};

export default Home;
